"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var SingpassContainer_1 = require("./singpass/SingpassContainer");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var identityVerificationContainerStyles_1 = require("./identityVerificationContainerStyles");
var SingpassAccess_1 = require("./singpass/enum/SingpassAccess");
var CustomerInformation_1 = require("../customerInformation/CustomerInformation");
var IdentityVerificationContainer = function () {
    var _a = react_1.useState(), verificationData = _a[0], setVerificationData = _a[1];
    var _b = react_1.useState(false), isAccepted = _b[0], setIsAccepted = _b[1];
    var identityVerification = usePlatformConfig_1.default().platformConfig.platformFeatures.identityVerification;
    var styles = identityVerificationContainerStyles_1.default();
    var _c = verificationData || {}, progress = _c.progress, state = _c.state;
    if (identityVerification === 'singpass') {
        return (<core_1.Container className={styles.root} data-test="checkout:identityVerification:container">
        <SingpassContainer_1.default isAccepted={isAccepted} verificationData={verificationData} setIsAccepted={setIsAccepted} setVerificationData={setVerificationData}/>

        {progress === SingpassAccess_1.SingpassAccess.Granted && !!state && isAccepted && <CustomerInformation_1.default stateId={state}/>}
      </core_1.Container>);
    }
    return null;
};
exports.default = IdentityVerificationContainer;
